import type { AxiosResponse } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import type { ShortenedLinkPayload, ShortenedLink } from '@/types/urlShortener';
import ajax from '@/utils/ajax';

export const urlShortenerRepository = {
  async shortenLink({
    host,
    originalLink
  }: {
    host: string;
    originalLink: string;
  }): Promise<ShortenedLink> {
    const path = '/api/links/';
    const { data } = await ajax.post<ShortenedLinkPayload, AxiosResponse<ShortenedLink>>({
      data: { original_url: originalLink },
      url: `${host}${path}`
    });

    return data;
  }
};

const UrlShortenerRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async shortenLink(originalLink: string): Promise<ShortenedLink> {
      return urlShortenerRepository.shortenLink({ host, originalLink });
    }
  };
};

export default UrlShortenerRepository;
